module.exports = __webpack_public_path__ + "img/apple-logo-white.fc2b70f5.svg";